import { IDropdownOption } from "@fluentui/react";

export interface ICodeDescriptionItem {
    code: string;
    description?: string;
}

export interface ISearchedDistributionItem {
    distributionCode: string;
    description?: string;
}

export const buildUniqueCodeDropdownOptions = (
    items: ReadonlyArray<ICodeDescriptionItem>
): IDropdownOption[] => {
    const optionsByNormalizedCode = new Map<string, IDropdownOption>();

    items.forEach(item => {
        const code = item.code?.trim();

        if (!code) {
            return;
        }

        const normalizedCode = code.toLowerCase();

        if (optionsByNormalizedCode.has(normalizedCode)) {
            return;
        }

        const description = item.description?.trim();
        const normalizedDescription = description?.toLowerCase();

        const descriptionAlreadyContainsCode =
            normalizedDescription === normalizedCode ||
            normalizedDescription?.startsWith(`${normalizedCode} -`);

        optionsByNormalizedCode.set(normalizedCode, {
            key: code,
            text: !description
                ? code
                : descriptionAlreadyContainsCode
                    ? description
                    : `${code} - ${description}`
        });
    });

    return Array
        .from(optionsByNormalizedCode.values())
        .sort((left, right) => String(left.key).localeCompare(String(right.key)));
};

export const getDistributionOptions = (
    distributions: ReadonlyArray<ICodeDescriptionItem> | undefined,
    searchResults: ReadonlyArray<ISearchedDistributionItem> | undefined,
    distributionPrefix: string | undefined,
    selectedKeys: ReadonlyArray<string>
): IDropdownOption[] => {
    const baseItems = (distributions ?? []).map(distribution => ({
        code: distribution.code,
        description: distribution.description
    }));

    const searchedItems = (searchResults ?? []).map(distribution => ({
        code: distribution.distributionCode,
        description: distribution.description
    }));

    const filteredItems = [...baseItems, ...searchedItems].filter(item => {
        if (!distributionPrefix) {
            return true;
        }

        const codePrefix = item.code?.match(/[A-Z\s]+/)?.join("");
        return codePrefix === distributionPrefix;
    });

    const selectedItems = selectedKeys.map(code => ({
        code,
        description: code
    }));

    return buildUniqueCodeDropdownOptions([
        ...filteredItems,
        ...selectedItems
    ]);
};
